import React from "react"
import { useSiteMetadata } from "../hooks/use-site-metadata"

export const Seo = ({ title, description, pathname, children }) => {
    const { title: defaultTitle, description: defaultDescription, siteUrl, twitterUsername, keywords } = useSiteMetadata()

    const seo = {
        title: title || defaultTitle,
        description: description || defaultDescription,
        url: `${siteUrl}${pathname || ``}`,
        twitterUsername,
        keywords: keywords
    }

    return (
        <>
            <title>{seo.title}</title>
            <meta name="description" content={seo.description} />
            <meta name="title" content={seo.title} />
            <meta name="url" content={seo.url} />
            <meta name="description" content={seo.description} />
            <meta name='keywords' content={seo.keywords} />
            {children}
        </>
    )
}